import React from 'react';

import { MobileScreenshotDetails } from 'src/common/types/MobileSingleSessionTypes';

export const getBoundingBoxStyles = (
	screenshotDetails: MobileScreenshotDetails,
	scale: number
): React.CSSProperties => {
	const croppedWidth =
		Math.min(
			screenshotDetails.boundingBox.width,
			screenshotDetails.viewportWidth - screenshotDetails.boundingBox.x
		) * scale;
	const croppedHeight =
		Math.min(
			screenshotDetails.boundingBox.height,
			screenshotDetails.viewportHeight - screenshotDetails.boundingBox.y
		) * scale;

	return {
		left: `${screenshotDetails.boundingBox.x * scale}px`,
		top: `${screenshotDetails.boundingBox.y * scale}px`,
		width: `${croppedWidth}px`,
		height: `${croppedHeight}px`
	};
};
